import React, { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import DashboardListCard from 'modules/common/dashboard/DashboardListCard';
import NovDashboardContainer from './containers/NovDashboardContainer';
import * as actions from './action';
import * as c from './constant';

function TransactionsContainer({ totalStats, getTotalStats }) {
  const returnTaxPaymentData = () => {
    const data = _.get(totalStats, 'item.total_ovr_payment_per_status');
    return {
      label: 'Violations',
      total: _.get(totalStats, 'item.total', 0),
      // photo: ''
      list: [
        { label: 'Draft', value: _.get(data, 'DRAFT', 0), borderClassName: 'pickup' },
        { label: 'Pending', value: _.get(data, 'PENDING', 0), borderClassName: 'waiting' },
        { label: 'Expired Reference Number', value: _.get(data, 'EXPIRED REFERENCE NUMBER', 0), borderClassName: 'received' },
        { label: 'Waiting for Payment', value: _.get(data, 'WAITING FOR PAYMENT', 0), borderClassName: 'waiting' },
        { label: 'Paid', value: _.get(data, 'PAID', 0), borderClassName: 'paid' },
      ],
    }
  };

  useEffect(() => {
    getTotalStats();
  }, []);

  return (
    <div className="container-fluid mb-3">
      <div className="row">
        <div className="col-4 pl-0">
          <DashboardListCard data={returnTaxPaymentData()} />
        </div>
        <div className="col-8 pr-0">
          <NovDashboardContainer />
        </div>
      </div>
    </div>
  );
}

TransactionsContainer.propTypes = {
  totalStats: PropTypes.instanceOf(Object).isRequired,
  getTotalStats: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  totalStats: _.get(api, `${c.GET_TOTAL_STATS}`) || {},
});

const enhance = _.flowRight([
  withRouter,
  connect(mapStateToProps, actions),
]);

export default enhance(TransactionsContainer);
